var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcoProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27096 13.9795C1.08376 14.307 0.709381 14.4474 0.381796 14.307C0.05421 14.1199 -0.0861839 13.7455 0.05421 13.4179C1.31775 10.7972 3.98524 9.06567 6.93351 9.06567C9.83498 9.06567 12.5025 10.7972 13.766 13.4179C13.9532 13.7455 13.8128 14.1199 13.4852 14.307C13.1576 14.4474 12.7365 14.307 12.5961 13.9795C11.5665 11.78 9.367 10.376 6.93351 10.376C4.50001 10.376 2.30051 11.78 1.27096 13.9795Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93356 0.361328C9.13306 0.361328 10.9582 2.18645 10.9582 4.38595C10.9582 6.58545 9.13306 8.41057 6.93356 8.41057C4.68726 8.41057 2.90894 6.58545 2.90894 4.38595C2.90894 2.18645 4.68726 0.361328 6.93356 0.361328ZM6.93356 1.67167C5.43602 1.67167 4.21928 2.88842 4.21928 4.38595C4.21928 5.88349 5.43602 7.10023 6.93356 7.10023C8.43109 7.10023 9.64784 5.88349 9.64784 4.38595C9.64784 2.88842 8.43109 1.67167 6.93356 1.67167Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcoProfile);
export default __webpack_public_path__ + "static/media/menu-ico_profile.ceef676900f6505d0748b00b8887263e.svg";
export { ForwardRef as ReactComponent };